import { ReferenceOutcomeStatus } from '@/lib/apollo/model/outcome'

export const shouldShowReferenceDetails = (
  outcomeStatus: ReferenceOutcomeStatus,
): boolean =>
  [
    ReferenceOutcomeStatus.awaitingReview,
    ReferenceOutcomeStatus.pass,
    ReferenceOutcomeStatus.fail,
  ].includes(outcomeStatus)

export const shouldShowDecisionComments = (
  outcomeStatus: ReferenceOutcomeStatus,
): boolean =>
  [ReferenceOutcomeStatus.awaitingReview, ReferenceOutcomeStatus.fail].includes(
    outcomeStatus,
  )
